import { elementIsInViewport, selectedElementAll } from "../utils/element-handlers.utils";
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import $ from 'jquery';
import { swiperSliderTabindexFix } from "../utils/swiper-utils";

function SliderComponent(sliderElement: HTMLElement) {
    const swiper = new Swiper(sliderElement, {
        loop: true,
        autoHeight: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: '.swiper-pagination',
            bulletClass: 'n-slider-pagination-bullet',
            bulletActiveClass: 'n-slider-pagination-bullet-active',
            clickable: true,
            renderBullet: function (index, className) {
                return `<button aria-label="Go to slide ${index + 1}" class="${className}"></button>`;
            },
        },
        modules: [
            Autoplay,
            Pagination
        ]
    });

    swiperSliderTabindexFix(swiper);

    return { swiper };
}

export default function initSliderComponent() {
    selectedElementAll('.n-slider', sliderElement => {
        const sliderElementId = sliderElement.getAttribute('id');
        const { swiper } = SliderComponent(sliderElement);

        switch (sliderElementId) {
            case 'home-just-opened-slider':
                caseHomeJustOpenedSlider(sliderElement, swiper);
                break;
        }
    });
}

function caseHomeJustOpenedSlider(
    sliderElement: HTMLElement,
    swiper: Swiper
) {
    const $sliderElement = $(sliderElement);
    const $parentCardElement = $sliderElement.parents('.n-card');
    const $infoInnerElements = $parentCardElement.find('.n-card-info-inner');
    const $infoElements = $parentCardElement.find('.n-card-info');
    let sliderIsVisible = elementIsInViewport(sliderElement);

    $infoInnerElements.css({
        transition: '300ms',
        margin: '0'
    });

    showInfo(swiper.realIndex);

    swiper.on('slideChangeTransitionStart', (swiperHander) => {
        showInfo(swiperHander.realIndex);
    });

    $infoElements.on('mouseenter', pauseSlider);
    $infoElements.on('mouseleave', playSlider);

    $(window).on('scroll resize', function (event) {
        sliderIsVisible = elementIsInViewport(sliderElement);

        if (sliderIsVisible) {
            if (swiper.autoplay.paused) {
                swiper.autoplay.resume();
            }
        }
        else {
            if (swiper.autoplay.running) {
                swiper.autoplay.pause();
            }
        }
    });

    function showInfo(indexToShow: number) {
        $infoInnerElements.each(function (infoElementIndex) {
            const infoElement = this;

            if (infoElementIndex === indexToShow) {
                infoElement.style.transitionDelay = '400ms';
                infoElement.style.opacity = '1';
                infoElement.style.pointerEvents = 'all';
                infoElement.style.position = 'relative';
                infoElement.style.transform = 'none';
                infoElement.style.visibility = 'visible';
            }
            else {
                infoElement.style.transitionDelay = '0ms';
                infoElement.style.opacity = '0';
                infoElement.style.pointerEvents = 'none';
                infoElement.style.position = 'absolute';
                infoElement.style.transform = 'translateX(16px)';
                infoElement.style.visibility = 'hidden';
            }
        })
    }

    function playSlider() {
        if (sliderIsVisible && swiper.autoplay.paused) {
            swiper.autoplay.resume();
        }
    }

    function pauseSlider() {
        if (sliderIsVisible && swiper.autoplay.running) {
            swiper.autoplay.pause();
        }
    }
}